"use client";

import { ModalTabContent } from "@packages/ui";

import { SelectLengthContent } from "./SelectLengthContent.emotion";

export const SelectLengthTabContent = () => (
  <ModalTabContent value={"lengthSelectMenu"}>
    <SelectLengthContent />
  </ModalTabContent>
);
